export const contacts = '联系电话：(0898) 38218621，客服QQ：3579179004、3165727040'

export default contacts
